import React from 'react';

import HomePage from './HomePage';

const Club = (props) => (<HomePage context={props.pageContext} />);

export default Club;
